/**
 * The badges of a flagged repo (utils/repoFlags.js), the same wherever a service or a context repo is listed (Apps,
 * the Code tree, the Files tab, the Home's Apps): "Read-only" (a lock) when nobody, person or agent, can change its
 * files, and "Context only" when it is never built or started. Nothing for a repo without flags.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { BookOpen, Lock } from '@phosphor-icons/react';
import './RepoFlags.css';

export const READ_ONLY_TIP = 'Read-only: nobody, people or AI agents, can change, commit or push its files';
export const NO_BUILD_TIP = 'No build: never built or started, used as context';

export default function RepoFlagBadges({ flags = null, compact = false, testId = undefined }) {
  if (!flags || (!flags.readOnly && !flags.noBuild)) { return null; }
  return (
    <span className={`repo-flags${compact ? ' is-compact' : ''}`} data-testid={testId}>
      {flags.readOnly && (
        <span aria-label="Read-only" className="repo-flag is-read-only" role="img" title={READ_ONLY_TIP}>
          <Lock aria-hidden size={compact ? 11 : 12} weight="bold" />
          {!compact && <span aria-hidden>Read-only</span>}
        </span>
      )}
      {flags.noBuild && (
        <span aria-label="Context only" className="repo-flag is-context" role="img" title={NO_BUILD_TIP}>
          <BookOpen aria-hidden size={compact ? 11 : 12} weight="bold" />
          {!compact && <span aria-hidden>Context only</span>}
        </span>
      )}
    </span>
  );
}

RepoFlagBadges.propTypes = {
  // Icons only (a tree row).
  compact: PropTypes.bool,
  flags: PropTypes.shape({ noBuild: PropTypes.bool, readOnly: PropTypes.bool }),
  testId: PropTypes.string,
};
